<template>
  <span
    v-if="showValue"
    id="for-test-decimal-static"
    class="decimal-static"
  >
    <span v-if="zeroIfLittle && Number(displayValue) < 0">
      ~0
    </span>
    <span
      v-else
      id="for-test-mnemonic-display"
      :visualIndent="visualIndent"
      class="value"
    >
      {{ displayValue }}
    </span>
    <template v-if="showAddition">
      <span
        v-if="checkCurrency"
        id="for-test-mnemonic"
        class="mnemonic"
      >{{ checkCurrency }}</span>
      <span
        v-else
        class="no-currency"
      >
        NTN
        <AuTooltip description="NO TOKEN NAME" />
      </span>
    </template>
  </span>
  <span v-else-if="noneIfEmpty">None</span>
  <span v-else>-</span>
</template>

<script>
import _ from "lodash";
import BigNumber from "bignumber.js";

export default {
  name: "AuDecimalStatic",

  props: {
    value: {
      type: [String, Number, BigNumber],
      default: ""
    },

    decimal: {
      type: Number,
      default: 0
    },

    indent: {
      type: Number,
      default: 2
    },

    //Валюта
    addition: {
      type: String,
      default: ""
    },

    showAddition: {
      type: Boolean,
      default: true
    },

    visualIndent: {
      type: Boolean,
      default: true
    },

    noneIfEmpty: {
      type: Boolean,
      default: false
    },

    zeroIfLittle: {
      type: Boolean,
      default: false
    },

    smartIndent: {
      type: Boolean,
      default: false
    },

    trimZeros: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },

  computed: {
    showValue() {
      const value = this.value ? this.value.toString().replace(",", ".") : 0;

      if (this.noneIfEmpty && !BigNumber(value).toNumber()) {
        return false;
      }

      return !BigNumber(value).isNaN();
    },

    displayValue() {
      let value = this.formatedValue;
      if (value && value.includes(".")) {
        const indent = this.getIndent(value);
        const fractionalPart = _.split(value, ".")[1];

        value = _.split(value, ".")[0] + "." + _.chain(fractionalPart).take(indent).join("").value();

        value = BigNumber(value).toFormat(indent, {
          groupSeparator: "\u00A0",
          decimalSeparator: ",",
          groupSize: 3,
          roundingMode: BigNumber.ROUND_DOWN
        });
      }
      else {
        value = Number(value).toLocaleString("ru", {
          maximumFractionDigits: this.indent,
          roundingMode: "trunc"
        });
      }

      value = value.replace(",", ".");

      return value;
    },

    checkCurrency() {
      if (this.addition == "-") {
        return null;
      }
      else {
        return this.addition;
      }
    },

    formatedValue() {
      let value = this.value ? this.value.toString().replace(",", ".") : 0;

      let result = "";

      if (this.decimal == 0) {
        return value;
      }

      if (typeof this.value == "number") {
        result = BigNumber(value);
        result = result.toFixed(this.decimal, BigNumber.ROUND_DOWN);
      }
      else {
        result = BigNumber(value).dividedBy(BigNumber(10).pow(this.decimal)).toFixed(this.decimal);
      }

      return result;
    }
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    getIndent(value) {
      let indent = this.indent;

      let fractionalPart = _.split(value, ".")[1];

      if (this.smartIndent) {
        let zeroCount = 0;
        for (let i = 0; i <= fractionalPart.length; i++) {
          if (fractionalPart[i] === "0") {
            zeroCount++;
          }
          else {
            break;
          }
        }

        indent += zeroCount;
      }

      fractionalPart = _.take(fractionalPart, indent);

      if (this.trimZeros) {
        let zeroFromEndCount = 0;
        for (let i = fractionalPart.length - 1; i >= 0; i--) {
          if (fractionalPart[i] === "0") {
            zeroFromEndCount++;
          }
          else {
            break;
          }
        }

        indent -= zeroFromEndCount;

        const lengthOfFractionalPartWithoutZeroes = fractionalPart.length - zeroFromEndCount;
        indent = _.min([indent, lengthOfFractionalPartWithoutZeroes]);
      }

      return indent;
    }
  }
};

</script>

<style scoped lang="scss">
.no-currency {
  color: grey;
}

.mnemonic {
  text-wrap: nowrap;
}

.decimal-static {
  display: inline-flex;
}

.value[visualIndent=true] {
  margin-right: 4px;
}

.value {
  display: block;
}
</style>